// react
import React, { Fragment, useEffect, useState } from 'react';
// styles
import styles from './index.module.scss';
// redux
/***************************************************************************/
/* Name : QuizItem React Component */
/***************************************************************************/
const QuizItem = React.memo(
  ({ questionObj, setAnswerTrue, setAnswerFalse }) => {
    // reducer
    /******************************************************************/
    /* useEffect */
    /******************************************************************/
    useEffect(() => {
      (async () => {})();
    }, []);
    /******************************************************************/
    /* functions */
    /******************************************************************/
    return (
      <Fragment>
        <div className={styles['question-body']}>
          <div className={styles['question']}>
            <span>{questionObj.question}</span>
          </div>
          <div className={styles['answers']}>
            <div className={styles['answer']}>
              <input
                type='radio'
                name={questionObj.index + 't'}
                id={questionObj.index + 't'}
                onChange={(e) => {
                  if (e.target.checked) {
                    setAnswerTrue(questionObj.index);
                  }
                }}
              />
              <label htmlFor={questionObj.index + 't'}>صحيح</label>
            </div>
            <div className={styles['answer']}>
              <input
                type='radio'
                name={questionObj.index + 't'}
                id={questionObj.index + 'f'}
                onChange={(e) => {
                  if (e.target.checked) {
                    setAnswerFalse(questionObj.index);
                  }
                }}
              />
              <label htmlFor={questionObj.index + 'f'}>خطأ</label>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
);

export { QuizItem };
